export default __webpack_public_path__ + "static/media/antp_nomo15_17oct_registrominiatura.e4ce38f3.jpg";